export const iconFontAwesomeSportsFitnessShoePrints = (
	<i className="fa-solid fa-shoe-prints"></i>
);
